export default (() => {
  return globalThis.navigator?.onLine ?? true;
});